import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { LoginSignupComponent } from '../login-signup.component';
import { AppContext } from 'src/app/services/app-context.service';


@Component({
  selector: 'travel-ui-welcome-popup',
  templateUrl: './welcome-popup.component.html',
  styleUrls: ['./welcome-popup.component.scss']
})
export class WelcomePopupComponent implements OnInit {

  constructor(public router: Router, public dialog: MatDialog, public appContext: AppContext) { }

  ngOnInit(): void {
  }

  backtologin() {
    if (this.appContext?.siteName === 'Gocaribbea' || this.appContext?.siteName == 'SecretEscapades') {
      this.router.navigate(['/'])
      this.openModal();
    } else {
      this.router.navigate(['login'])
    }

  }

  openModal() {
    this.dialog.open(LoginSignupComponent);
  }
}
